import { render, staticRenderFns } from "./StatisticsTrendsBook.vue?vue&type=template&id=d6880c06&scoped=true"
import script from "./StatisticsTrendsBook.vue?vue&type=script&lang=ts"
export * from "./StatisticsTrendsBook.vue?vue&type=script&lang=ts"
import style0 from "./StatisticsTrendsBook.vue?vue&type=style&index=0&id=d6880c06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6880c06",
  null
  
)

export default component.exports